module.exports = __webpack_public_path__ + "img/TRINITY-BOARD-LOGO_RGB_LOGO_horizontal.502f7f51.svg";